import React from "react";
import { FaYoutube, FaInstagram, FaLinkedinIn, FaFacebookF } from "react-icons/fa";
import Logo from "../assets/logo.png"; // update the path as needed

const Footer = () => {
  return (
    <footer className="relative bg-[#FFEBE0]/20 w-screen max-w-none text-center pt-24 pb-8 overflow-hidden">
      {/* Curved Shape - Bottom to Top */}
      <div className="absolute bottom-0 left-0 w-full h-[230px] bg-white rounded-t-[50%]"></div>

      <div className="relative z-10 flex flex-col items-center justify-center space-y-4">
        {/* Logo */}
        <div className="flex items-center space-x-2">
          <img src={Logo} alt="BTech Mathematics" className="w-[250px]" />
        </div>

        {/* Links */}
        <div className="flex flex-wrap justify-center gap-6 text-gray-600 text-sm">
          <a href="#" className="hover:text-[#F15A29] transition">
            Privacy policy
          </a>
          <a href="#" className="hover:text-[#F15A29] transition">
            Disclaimer / Terms and Condition
          </a>
        </div>

        {/* Social Icons */}
        <div className="flex justify-center gap-4 text-[#F15A29] mt-2">
          <a href="https://www.youtube.com/@btechmathematics" className="hover:scale-110 transition">
            <FaYoutube className="text-lg" />
          </a>
          <a href="https://www.instagram.com/btech_mathematics?igsh=aGprejRpdGpibjA3" className="hover:scale-110 transition">
            <FaInstagram className="text-lg" />
          </a>
          {/* <a href="#" className="hover:scale-110 transition">
            <FaLinkedinIn className="text-lg" />
          </a> */}
          <a href="https://www.facebook.com/share/16umiC7BPC/" className="hover:scale-110 transition">
            <FaFacebookF className="text-lg" />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
